import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOpenNewTab = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.7797 6.21999C17.8569 6.29717 17.9138 6.38696 17.9503 6.48273L17.9982 6.70395C17.9992 6.71954 17.9997 6.73527 17.9997 6.7511L17.9997 17.0026C17.9997 17.4174 17.6634 17.7537 17.2486 17.7537C16.8338 17.7537 16.4975 17.4174 16.4975 17.0026L16.4975 8.56445L7.35223 17.7097C7.0589 18.003 6.58333 18.003 6.29 17.7097C5.99668 17.4164 5.99668 16.9408 6.29 16.6475L15.4353 7.50221L6.99711 7.50222C6.58229 7.50222 6.24601 7.16594 6.24601 6.75111C6.246 6.33629 6.58229 6.00001 6.99711 6.00001L17.2486 6L17.2509 6C17.3489 6.00029 17.4426 6.01939 17.5284 6.05387C17.6199 6.09053 17.7056 6.1459 17.7797 6.21999Z",
		fill: "currentColor"
	})
});
export { SvgIconOpenNewTab as ReactComponent };
